import { Component } from '@angular/core';
import { SessionService } from '../../../authentication/session.service';
import { FormBuilder, Validators } from '@angular/forms';
import {
  RouteConfigLoadEnd,
  RouteConfigLoadStart,
  Router,
} from '@angular/router';
import { Title } from '@angular/platform-browser';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { whiteLabelTarget } from 'src/app/utils/whiteLabel';

declare const behamics: any;

@Component({
  selector: 'app-signup-premium',
  templateUrl: './signup-premium.component.html',
  styleUrls: [
    './signup-premium.component.css',
    '../signup/signup.component.css',
    '../login/login.component.css',
    '../../login/login.component.css',
    '../../../seo/ai-analysis/ai-analysis.component.css',
  ],
})
export class SignupPremiumComponent {
  constructor(
    private sessionService: SessionService,
    private fb: FormBuilder,
    private route: Router,
    private titleService: Title,
    private localStorageService: LocalStorageService,
  ) {
    this.route.events.subscribe((event) => {
      if (event instanceof RouteConfigLoadStart) {
        this.isSeoModuleLoading = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        this.isSeoModuleLoading = false;
      }
    });
  }

  isSeoModuleLoading: boolean = false;

  loginLoading: boolean = false;

  form = this.fb.group({
    fullname: ['', Validators.required],
    email: ['', Validators.required],
    password: ['', Validators.required],
  });

  moreInfo: string = '';

  isRedirectedFromWeb: boolean = false;

  isGermanVersion: boolean = false;
  isLeadsVersion: boolean = false;

  dataToSend: any = {};

  listOfIssues: any[] = [
    {
      description: 'Keyword is too similar to Page Title',
      issue: 'Content',
      blurred: false,
    },
    {
      description: 'Introduction is not strongly related to H2 Content',
      issue: 'Keywords',
      blurred: true,
    },
    {
      description: 'Keyword is too similar to Content',
      issue: 'Linking',
      blurred: true,
    },
    {
      description: 'Keyword is too similar to H2 Content',
      issue: 'Technical',
      blurred: true,
    },
  ];

  is7DaysFreeTrial: boolean = false;

  whiteLabelTarget = whiteLabelTarget;

  ngOnInit() {
    document.body.classList.remove('dark-theme');

    if (this.whiteLabelTarget) {
      this.titleService.setTitle(
        this.whiteLabelTarget.description + 'Dashboard',
      );
    } else {
      this.titleService.setTitle('Signup - Organic');
    }

    this.localStorageService.set('organic_signup_premium', true);

    const params = new URLSearchParams(window.location.search);
    params.forEach((value, key) => {
      if (key === 'seo_url') {
        this.localStorageService.set('seo_url_from_web', value);
        this.isRedirectedFromWeb = true;
      } else if (key === 'ftseven') {
        this.is7DaysFreeTrial = true;
      } else if (key === 'fbclid') {
        this.localStorageService.set('fbclid', value);
      } else if (key === 'gclid') {
        this.localStorageService.set('gclid', value);
      } else if (key === 'utm_campaign') {
        this.localStorageService.set('utm_campaign', value);
      } else if (key === 'utm_medium') {
        this.localStorageService.set('utm_medium', value);
      } else if (key === 'utm_source') {
        this.localStorageService.set('utm_source', value);
      }
    });

    this.getSignupCountryVersion();
  }
  getSignupCountryVersion(): void {
    const windowUrl = this.route.url;

    let signUpUrl = 'signup_organic_premium';

    if (windowUrl.startsWith('/signup_organic_premium_1')) {
      signUpUrl = 'signup_organic_premium_1';
      this.isGermanVersion = true;
    } else if (windowUrl.startsWith('/signup_organic_leads')) {
      signUpUrl = 'signup_organic_leads';
      this.isLeadsVersion = true;
    }

    this.localStorageService.set('signup_organic_url', signUpUrl);
  }
  showPassword: boolean = false;
  toogleShowPassword() {
    this.showPassword = !this.showPassword;
  }
  signup() {
    if (this.form.valid) {
      const data = {
        ...this.form.value,
        signup_premium: true,
        is_leads_user: this.isLeadsVersion,
        ...(this.is7DaysFreeTrial && { is_7_days_free_trial: true }),
      };
      this.loginLoading = true;
      this.isSeoModuleLoading = true;

      this.sessionService.signup(data).subscribe({
        next: (res) => {
          if (res?.message.toLocaleLowerCase() == 'success') {
            this.pushAdsData(false, null);

            this.sessionService
              .authenticated(
                this.form.value?.email?.toLowerCase() || '',
                this.form.value?.password || '',
              )
              .subscribe({
                next: (data: any) => {
                  if (data['status'] == 3) {
                    this.loginLoading = false;
                    this.localStorageService.set('organicLogin', true);
                    this.localStorageService.set('organic_signup', true);

                    if (data?.user?.is_7_days_free_trial) {
                      this.localStorageService.set(
                        'is_7_days_free_trial',
                        true,
                      );
                    }

                    this.sessionService.login(data);

                    const email: string =
                      this.localStorageService.get('email') || '';

                    // this.route.navigate(['organic_onboarding']);

                    if (
                      this.localStorageService.get('signup_organic_url') ==
                      'signup_organic_leads'
                    ) {
                      this.route.navigate(['verify-phone']);
                    } else if (
                      !data?.user?.phoneNumber &&
                      data?.user?.is_7_days_free_trial
                    ) {
                      this.sessionService
                        .getWebsiteTraffic(
                          this.localStorageService.get('seo_url_from_web') ||
                            '',
                        )
                        .subscribe((res) => {
                          // Ensure dataToSend is populated before adding traffic
                          if (
                            !this.dataToSend ||
                            Object.keys(this.dataToSend).length === 0
                          ) {
                            let user = null;
                            if (
                              behamics._getCookie(
                                behamics.variables.userStorageKey,
                              )
                            ) {
                              user = JSON.parse(
                                behamics._getCookie(
                                  behamics.variables.userStorageKey,
                                ),
                              );
                            } else {
                              user =
                                this.localStorageService.get(
                                  behamics.variables.userStorageKey,
                                ) || {};
                            }

                            this.dataToSend = {
                              fullname:
                                this.localStorageService.get('name') || '',
                              email:
                                this.localStorageService.get('email') || '',
                              sessionID: user
                                ? user.sessionID
                                : 'sessionID-Not-Found',
                              Product: 'Organic',
                              adType: 'facebook',
                              utm_source:
                                this.localStorageService.get('utm_source') ||
                                '',
                              utm_medium:
                                this.localStorageService.get('utm_medium') ||
                                '',
                              utm_campaign:
                                this.localStorageService.get('utm_campaign') ||
                                '',
                              event_type: 'all',
                              gclid:
                                this.localStorageService.get('gclid') || '',
                              fbclid:
                                this.localStorageService.get('fbclid') || '',
                              seo_url:
                                this.localStorageService.get(
                                  'seo_url_from_web',
                                ) || '',
                              referrer: 'AI Visibility Run My Audit',
                              signup: '1',
                              traffic: res.organic_traffic,
                            };
                          }

                          this.sessionService
                            .adTrackerEvents(this.dataToSend)
                            .subscribe((res) => {});

                          if (res.organic_traffic > 9999) {
                            try {
                              (window as any).fbq('track', 'Subscribe', {
                                eventID: behamics.metaEventId,
                              });

                              behamics._adConvertDashboard(email);
                            } catch (error) {
                              console.log(error);
                            }
                          }
                        });

                      // this.route.navigate(['verify-number']);
                      this.route.navigate(['organic_onboarding']);
                    } else {
                      this.localStorageService.set(
                        'showFullScreenBilling',
                        true,
                      );
                      this.route.navigate(['seo/billing']);
                    }
                  } else {
                    this.moreInfo = 'Something went wrong!';
                  }
                },
              });
          } else {
            if (res?.message) {
              this.moreInfo = res?.message;
            } else {
              this.moreInfo = 'Something went wrong!';
            }
          }
        },
        error: (error) => {
          this.loginLoading = false;
          this.moreInfo = 'Something went wrong!';
        },
      });
    }
  }

  pushAdsData(fromGoogle: any, result: any) {
    if (
      this.localStorageService.get('gclid_from_web') ||
      this.localStorageService.get('fbclid_from_web')
    ) {
      const sessionID = JSON.parse(
        (window as any).behamics._getCookie(
          (window as any).behamics.variables.userStorageKey,
        ),
      ).sessionID;

      const data = {
        fullname: !fromGoogle ? this.form.value?.fullname : result.user.name,
        sessionID: sessionID,
        Product: 'Organic',
        adType: 'google', // or "facebook"
        utm_source: this.localStorageService.get('utm_source_from_web') || '',
        utm_medium: this.localStorageService.get('utm_medium_from_web') || '',
        utm_campaign:
          this.localStorageService.get('utm_campaign_from_web') || '',
        event_type: 'signup',
        gclid: this.localStorageService.get('gclid_from_web') || '',
        fbclid: this.localStorageService.get('fbclid_from_web') || '',
        email: !fromGoogle ? this.form.value?.email : result.user.email,
        seo_url: this.localStorageService.get('seo_url_from_web') || '',
      };

      this.sessionService.pushAdsData(data).subscribe((res) => {
        console.log(res);
      });
    }
  }

  loginWithGoogle(event: any) {
    event.preventDefault();

    let url =
      'https://api.dashboard.behamics.com/api/auth/google?signup_premium=true';

    if (this.is7DaysFreeTrial) {
      url += '&is_7_days_free_trial=true';
    }

    url += '&origin=' + location.origin;

    const popup = window.open(
      url,
      'googleAuth',
      'popup=1,width=600,height=700',
    );
    window.addEventListener(
      'message',
      (event) => {
        if (event.data.type === 'GoogleLogin') {
          const { result } = event.data;
          if (result) {
            popup?.close();
            if (result.status === 3) {
              this.localStorageService.set('organicLogin', true);
              this.localStorageService.set('organic_signup', true);
              // this.pushAdsData(true, result);

              if (result?.user?.is_7_days_free_trial) {
                this.localStorageService.set('is_7_days_free_trial', true);
              }

              this.sessionService.login(result);

              // if (this.isRedirectedFromWeb) {
              //   this.route.navigate(['organic_onboarding']);
              // } else {
              //   this.sessionService.navigate(result);
              // }

              const email: string = this.localStorageService.get('email') || '';

              this.moreInfo = '';
              this.loginLoading = false;

              if (
                !result?.user?.phoneNumber &&
                result?.user?.is_7_days_free_trial
              ) {
                this.sessionService
                  .getWebsiteTraffic(
                    this.localStorageService.get('seo_url_from_web') || '',
                  )
                  .subscribe((res) => {
                    // Ensure dataToSend is populated before adding traffic
                    if (
                      !this.dataToSend ||
                      Object.keys(this.dataToSend).length === 0
                    ) {
                      let user = null;
                      if (
                        behamics._getCookie(behamics.variables.userStorageKey)
                      ) {
                        user = JSON.parse(
                          behamics._getCookie(
                            behamics.variables.userStorageKey,
                          ),
                        );
                      } else {
                        user =
                          this.localStorageService.get(
                            behamics.variables.userStorageKey,
                          ) || {};
                      }

                      this.dataToSend = {
                        fullname: this.localStorageService.get('name') || '',
                        email: this.localStorageService.get('email') || '',
                        sessionID: user
                          ? user.sessionID
                          : 'sessionID-Not-Found',
                        Product: 'Organic',
                        adType: 'facebook',
                        utm_source:
                          this.localStorageService.get('utm_source') || '',
                        utm_medium:
                          this.localStorageService.get('utm_medium') || '',
                        utm_campaign:
                          this.localStorageService.get('utm_campaign') || '',
                        event_type: 'all',
                        gclid: this.localStorageService.get('gclid') || '',
                        fbclid: this.localStorageService.get('fbclid') || '',
                        seo_url:
                          this.localStorageService.get('seo_url_from_web') ||
                          '',
                        referrer: 'AI Visibility Run My Audit',
                        signup: '1',
                        traffic: res.organic_traffic,
                      };
                    }

                    this.sessionService
                      .adTrackerEvents(this.dataToSend)
                      .subscribe((res) => {});

                    if (res.organic_traffic > 9999) {
                      try {
                        (window as any).fbq('track', 'Subscribe', {
                          eventID: behamics.metaEventId,
                        });

                        behamics._adConvertDashboard(email);
                      } catch (error) {
                        console.log(error);
                      }
                    }
                  });

                // this.route.navigate(['verify-number']);
                this.route.navigate(['organic_onboarding']);
              } else if (
                this.localStorageService.get('signup_organic_url') ==
                'signup_organic_leads'
              ) {
                this.route.navigate(['verify-phone']);
              } else {
                this.route.navigate(['seo/billing']);
              }
            } else {
              this.moreInfo = result.message;
              this.loginLoading = false;
            }
          }
        }
      },
      { once: true },
    );
  }
  redirectToLogin() {
    this.route.navigate(['login_organic']);
  }

  showInputs: boolean = false;
  loginWithEmail(event: any) {
    if (!this.showInputs) {
      event.preventDefault();
      this.showInputs = true;
      return;
    }
  }
  showInputsFunc() {
    this.showInputs = true;
  }
  privatcyPolicyClick() {
    window.open('https://behamics.com/legal/privacy-policy-en.pdf', '_blank');
  }
}
